import React from "react";
import "./Footer.css";

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-brand">
          <h3>Maa Bhagwati Construction</h3>
          <p>Building Jaipur with trust, quality and 50+ years of experience.</p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <a href="#about">About</a>
          <a href="#services">Services</a>
          <a href="#projects">Projects</a>
          <a href="#contact">Contact</a>
        </div>

        <div className="footer-contact">
          <h4>Contact</h4>
          <p>Kalwar Road, Jhotwara, Jaipur</p>
          <p>Phone: +91 96100 71616</p>
          <p>Email: constructionmaabhagwati@gmail.com</p>
        </div>

        <div className="footer-map">
          <h4>Find Us</h4>
          <iframe
            src="https://www.google.com/maps?q=26.9584292,75.7169779&z=17&output=embed"
            width="100%"
            height="200"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Maa Bhagwati Construction Location"
          ></iframe>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} MAA BHAGWATI CONSTRUCTION. ALL RIGHTS RESERVED.</span>
      </div>
    </footer>
  );
}

export default Footer;
